import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

const g_orgListMap = new Map<number, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
  return () => {
    g_eventEmitter.removeListener(CHANGE_EVENT, callback);
  };
}
function init(done) {
  UserStore.addChangeListener(_onUserChange);
  done?.();
}
function _onUserChange() {
  if (!UserStore.isLoggedIn()) {
    g_orgListMap.clear();
    _emit('update');
  }
}
function _getList(org_id: number) {
  return g_orgListMap.get(org_id);
}
export function useList(org_id: number) {
  const _get = React.useCallback(() => _getList(org_id), [org_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
export function useMediaGrant(org_id: number, grant_name: string) {
  const grant_lc = grant_name?.toLowerCase?.() ?? '';
  const list = useList(org_id);
  let ret;
  if (list) {
    ret = list.find((g) => g.grant_name.toLowerCase() === grant_lc) || null;
  }
  return ret;
}
const fetch = util.herd(
  (org_id: number, done?: (err?: any) => void) => {
    const opts = {
      url: `/web/1/org/${org_id}/media_grant`,
    };
    UserStore.get(opts, (err, body) => {
      if (err) {
        util.errorLog('MediaGrantStore.fetch: err:', err);
      } else if (body) {
        const old = g_orgListMap.get(org_id);
        if (!util.deepEqual(old, body.media_grant_list)) {
          g_orgListMap.set(org_id, body.media_grant_list);
          _emit('update');
        }
      }
      done?.(err);
    });
  },
  (arg) => String(arg)
);
export default {
  init,
  useList,
  useMediaGrant,
  fetch,
};
